module.exports = __webpack_public_path__ + "media/app/apple-badge-en-55bd0326.svg";